<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">{{ $t('reportAttendanceByStudent.pageTitle') }}</h1>
			<ts-breadcrumb :items="[
				{ text: $t('toHomePage'), href: '/' },
				{
					text: $t('reportAttendanceByStudent.pageTitle'),
					active: true
				}
			]" />
		</div>
		<div class="row">
			<div class="col-md-3">
				<ts-card>
					<ts-card-wrapper>
						<ts-loading-banner :loading="loading">
							<form>
								<fieldset>
									<legend>
										{{ $t('reportAttendanceByStudent.criteria') }}
									</legend>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportAttendanceByStudent.acYear')
											}}</label>
											<a-select style="width: 100%" v-model.number="model.ac_year_id" :options="ac_year_list"
												@change="acYearChange"></a-select>
											<div class="validate" v-if="errors.has('ac_year_id')">
												{{ errors.first('ac_year_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportAttendanceByStudent.subProgram')
											}}</label>
											<a-select style="width: 100%" v-model.number="model.acps_id" :options="sub_programs"
												:show-search="true" :filter-option="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													" @change="onSubChange" :disabled="!model.ac_year_id"></a-select>
											<div class="validate" v-if="errors.has('acps_id')">
												{{ errors.first('acps_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportAttendanceByStudent.acTerm')
											}}</label>
											<a-select style="width: 100%" v-model.number="model.ac_term_id" :options="ac_terms"
												:show-search="true" :filter-option="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													" @change="acTermChange"></a-select>
											<div class="validate" v-if="errors.has('ac_term_id')">
												{{ errors.first('ac_term_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('reportAttendanceByStudent.classOperation')
											}}</label>
											<a-select style="width: 100%" v-model="model.class_id" mode="multiple" :options="class_options"
												:show-search="true" :filter-option="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													" placeholder="All"></a-select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportAttendanceByStudent.year')
											}}</label>
											<select class="form-control" v-model="model.academic_year" ref="academic_year">
												<option :value="null" selected style="display: none">
													{{ $t('select') }}
												</option>
												<option v-for="(year, index) in academic_years" :value="year" :key="index">
													{{ year }}
												</option>
											</select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportAttendanceByStudent.semester')
											}}</label>
											<select class="form-control" v-model="model.academic_term" ref="academic_term">
												<option :value="null" selected style="display: none">
													{{ $t('select') }}
												</option>
												<option v-for="(year, index) in academic_terms" :value="year" :key="index">
													{{ year }}
												</option>
											</select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportAttendanceByStudent.degree')
											}}</label>
											<select class="form-control" v-model="model.degree">
												<option :value="null" selected style="display: none">
													{{ $t('select') }}
												</option>
												<option value="Associate">
													Associate
												</option>
												<option value="Bachelor">
													Bachelor
												</option>
												<option value="Master">
													Master
												</option>
											</select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportAttendanceByStudent.batch')
											}}</label>
											<input type="number" v-model="model.promotion" class="form-control kh-font only-border-bottom" />
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportAttendanceByStudent.reportType')
											}}</label>
											<div class="form-group">
												<div class="radio radio-css radio-inline">
													<input v-model="model.report_type" type="radio" id="summary" :value="'summary'" />
													<label for="summary">
														{{ $t('report.summary') }}
													</label>
												</div>
												<div class="radio radio-css radio-inline">
													<input v-model="model.report_type" type="radio" id="detail" :value="'details'" />
													<label for="detail">{{ $t('report.detail') }} </label>
												</div>
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12" v-show="this.model.report_type == 'details'">
											<label class="form-col-label control-label required">
												{{ $t('reportAttendanceByStudent.date') }}
											</label>
											<div>
												<a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
													@change="dateRangeChange">
													<template slot="renderExtraFooter"></template>
												</a-range-picker>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 text-right">
											<ts-button class="btn-block" outline color="success" @click.prevent="exportExcel"
												:waiting="exporting">{{ $t('excel')
												}}</ts-button>
										</div>
									</div>
								</fieldset>
							</form>
						</ts-loading-banner>
					</ts-card-wrapper>
				</ts-card>
			</div>
			<div class="col-md-9">
				<ts-card>
					<ts-card-wrapper>
						<form>
							<fieldset>
								<legend>{{ $t('reportAttendanceByStudent.preview') }}</legend>
								<ts-preview-pdf v-model="waiting" :src="src" />
							</fieldset>
						</form>
					</ts-card-wrapper>
				</ts-card>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
import moment from 'moment'

export default {
	name: 'reportAttendanceByStudent',
	data() {
		return {
			loading: false,
			waiting: false,
			exporting: false,
			src: '',
			errors: new Errors(),
			sub_programs: [],
			ac_terms: [],
			ac_year_list: [],
			class_options: [],
			rangeDate: [moment(), moment()],
			model: {
				acps_id: null,
				ac_term_id: null,
				ac_year_id: null,
				class_id: undefined,
				academic_year: null,
				academic_term: null,
				promotion: null,
				degree: null,
				report_type: 'summary'
			}
		}
	},
	computed: {
		...mapState('reportAcademic', [
			'academic_years',
			'academic_terms',
		]),
	},
	created() {
		this.fetchData()
	},
	methods: {
		...mapActions('reportAcademic', [
			'classAttendance',
			'getSubProgram',
			'getTerm',
			'getYear',
			'getClass'
		]),
		moment,
		async fetchData() {
			this.loading = true
			await this.getYear()
				.then(response => {
					this.ac_year_list = response.data.map(el => ({
						value: el.ac_year_id,
						label:
							el.ac_year +
							(el.ac_status_id == 1
								? ' ( Current ) '
								: el.ac_status_id == 2
									? ' ( History ) '
									: ' ( Next ) ')
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
			await this.getSubProgram()
				.then(response => {
					this.sub_programs = response.data.map(el => ({
						value: el.acps_id,
						label: el.acps_name_foreign
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onSubChange(acps_id) {
			this.model.ac_term_id = null
			this.model.class_id = undefined
			this.loading = true
			this.getTerm({
				filter: {
					acps_id: acps_id,
					ac_year_id: this.model.ac_year_id
				}
			})
				.then(response => {
					this.ac_terms = response.data.map(el => ({
						value: el.ac_term_id,
						label:
							el.term_name +
							(el.ac_status_id == 1
								? ' ( Current ) '
								: el.ac_status_id == 2
									? ' ( History ) '
									: ' ( Next ) ')
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		acYearChange() {
			this.model.acps_id = null
			this.model.ac_term_id = null
			this.model.class_id = undefined
		},
		acTermChange(ac_term_id) {
			this.loading = true
			this.getClass({
				filter: {
					ac_term_id: ac_term_id
				}
			})
				.then(response => {
					this.class_options = response.data
						.map(el => ({
							value: el.class_id,
							label: el.class_name
						}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		dateRangeChange(dateRange) {
			this.$store.commit(
				'reportAcademic/SET_DATE_FROM',
				dateRange[0].format('DD-MM-YYYY')
			)
			this.$store.commit(
				'reportAcademic/SET_DATE_TO',
				dateRange[1].format('DD-MM-YYYY')
			)
		},
		exportExcel() {
			this.exporting = true
			this.errors = new Errors()

			this.$store
				.dispatch('reportAcademic/attendanceByStudentExcel', this.model)
				.then(response => {
					let filename = trim(
						response.headers['content-disposition']
							.substring(
								response.headers['content-disposition'].indexOf('filename')
							)
							.replace('filename=', ''),
						'"'
					)
					FileDownload(response.data, filename)
				})
				.catch(err => {
					let error = JSON.parse(
						String.fromCharCode.apply(null, new Uint8Array(err))
					)
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => (this.exporting = false))
		}
	}
}
</script>
  